import React, { FunctionComponent } from "react"
import { OverlayTrigger } from "react-bootstrap"
import HRRService from "src/pages/hr_reports/utils/HRRService"
import HRRSortService from "src/pages/hr_reports/utils/HRRSortService"


const HRRViewReportTableHeader: FunctionComponent<{}> = () => {

    const { state, HRRServiceTooltip } = HRRService
    const { sortReportsByKey } = HRRSortService
    const { selectedReport } = state

    // const checkIfActive = (key: string) => {
    //     return  ? "HRRViewReportTableHeaderTHSortCarretActive" : "HRRViewReportTableHeaderTHSortCarretInactive"
    // }

    return (
        <thead>
            <tr id="hrr-view-report-table-header">
                {/*@ts-ignore*/}
                {selectedReport.properties.items.map((item, i) => {
                    const isActive = state.sortOptions.key === item.key
                    const asc = state.sortOptions.direction === "ASC"
                    return (
                        <th key={i}>
                            <div className={`HRRViewReportTableHeaderTH ${isActive ? "HRRViewReportTableHeaderTHSorted" : "HRRViewReportTableHeaderTHNotSorted"}`}>
                                <div className="HRRViewReportTableHeaderTHTitle">
                                    {item.title}
                                </div>
                                <div className="HRRViewReportTableHeaderTHSort">
                                    <OverlayTrigger placement="top" overlay={HRRServiceTooltip(`Sort by ${item.title} ascending`)}>

                                        <span
                                            className={`material-icons HRRViewReportTableHeaderTHSortIconA ${isActive && asc ? "HRRViewReportTableHeaderTHSortIconGreen" : "HRRViewReportTableHeaderTHSortIconBlack"}`}
                                            onClick={() => sortReportsByKey(item.key, "ASC")}
                                        >
                                            keyboard_arrow_up
                                        </span>
                                    </OverlayTrigger>
                                    <OverlayTrigger placement="bottom" overlay={HRRServiceTooltip(`Sort by ${item.title} descending`)}>
                                        <span
                                            className={`material-icons HRRViewReportTableHeaderTHSortIconB ${isActive && !asc ? "HRRViewReportTableHeaderTHSortIconGreen" : "HRRViewReportTableHeaderTHSortIconBlack"}`}
                                            onClick={() => sortReportsByKey(item.key, "DESC")}
                                        >
                                            keyboard_arrow_down
                                        </span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        </th>
                    )
                }
                )}
            </tr>
        </thead>
    )
}

export default HRRViewReportTableHeader